import script from "./ReceiptPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReceiptPage.vue?vue&type=script&setup=true&lang=ts"

import "./ReceiptPage.vue?vue&type=style&index=0&id=4413c6ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4413c6ee"]])

export default __exports__